import { genericActions } from "../../Everou/_actions/generic.actions";
import { OrganizationsActions } from "../../Organizations/_actions/OrganizationsActions";
import { PMSOrganizationSettingsService } from "../_services/PMSOrganizationSettingsService";

export const PMSOrganizationSettingsActions = {
    update,
    uploadVideo,
    deleteVideo,
};

function update(organizationUid: string, fields: Record<string, unknown>) {
    return async (dispatch) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            await PMSOrganizationSettingsService.update(
                organizationUid,
                fields,
            );
            await dispatch(
                OrganizationsActions.getOrganization(organizationUid),
            );
        }
    };
}

function uploadVideo(organizationUid: string, video: any) {
    return async (dispatch) => {
        return dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            await PMSOrganizationSettingsService.uploadVideo(
                organizationUid,
                video,
            );
            await dispatch(
                OrganizationsActions.getOrganization(organizationUid),
            );
        }
    };
}

function deleteVideo(organizationUid: string) {
    return async (dispatch) => {
        return dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            await PMSOrganizationSettingsService.deleteVideo(organizationUid);
            await dispatch(
                OrganizationsActions.getOrganization(organizationUid),
            );
        }
    };
}
